module.exports = __webpack_public_path__ + "img/cat-01.56b77de1.png";